module.exports = __webpack_public_path__ + "assets/0103_IFOK_WIM_MARKER_yellow_topic_je.5f84c8c5.svg";